import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SEOHead } from '../components/common/SEOHead';
import { CheckCircle, Download, ArrowRight } from 'lucide-react';

export default function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const isCatalog = searchParams.get('type') === 'catalog';

  useEffect(() => {
    // Track conversion
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-XXXXX/XXXXX',
        event_category: isCatalog ? 'catalog_download' : 'lead_form',
      });
    }
  }, [isCatalog]);

  return (
    <>
      <SEOHead
        title="Thank You - Silver Perfumes"
        description="Thank you for your interest. Our team will contact you shortly."
      />

      <div className="min-h-screen pt-32 pb-16 bg-[#F4F4F5] flex items-center" data-testid="thank-you-page">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            {/* Success Icon */}
            <div className="w-24 h-24 bg-[#0A0A0A] rounded-full flex items-center justify-center mx-auto mb-8">
              <CheckCircle className="h-12 w-12 text-[#C0C4CC]" />
            </div>

            <h1 className="heading-xl mb-4">Thank You!</h1>
            
            {isCatalog ? (
              <>
                <p className="text-gray-600 text-lg mb-8">
                  Your catalog download request has been received. Check your email 
                  for the download link, or click below to download immediately.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                  <a
                    href="#"
                    className="btn-silver inline-flex items-center justify-center gap-2"
                    onClick={(e) => {
                      e.preventDefault();
                      alert('Catalog PDF would download here');
                    }}
                  >
                    <Download className="h-4 w-4" />
                    Download Catalog Now
                  </a>
                </div>
              </>
            ) : (
              <p className="text-gray-600 text-lg mb-8">
                Your inquiry has been received. Our team will contact you within 
                24 hours to discuss your requirements.
              </p>
            )}

            <div className="silver-separator mx-auto mb-8" />

            <h2 className="heading-sm mb-6">What's Next?</h2>
            
            <div className="grid sm:grid-cols-3 gap-6 mb-12">
              <div className="bg-white p-6">
                <div className="w-8 h-8 bg-[#0A0A0A] text-white rounded-full flex items-center justify-center mx-auto mb-4 text-sm font-bold">
                  1
                </div>
                <p className="text-sm text-gray-600">
                  Our team reviews your inquiry
                </p>
              </div>
              <div className="bg-white p-6">
                <div className="w-8 h-8 bg-[#0A0A0A] text-white rounded-full flex items-center justify-center mx-auto mb-4 text-sm font-bold">
                  2
                </div>
                <p className="text-sm text-gray-600">
                  We prepare a customized quote
                </p>
              </div>
              <div className="bg-white p-6">
                <div className="w-8 h-8 bg-[#0A0A0A] text-white rounded-full flex items-center justify-center mx-auto mb-4 text-sm font-bold">
                  3
                </div>
                <p className="text-sm text-gray-600">
                  We contact you within 24 hours
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/products" className="btn-primary inline-flex items-center justify-center gap-2">
                Browse Products
                <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/" className="btn-secondary">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
